import React from 'react';
import styled from 'styled-components';
import { useRouter } from 'next/router';
import { Trans } from '@lingui/react';

export default function BoatsList() {
  const router = useRouter();

  const clearSearch = () => {
    const currentQueries = router.query;

    delete currentQueries.passengerCount;
    delete currentQueries.priceFrom;
    delete currentQueries.priceTo;
    delete currentQueries.boatSizeFrom;
    delete currentQueries.boatSizeTo;
    delete currentQueries.isInstantBookable;
    delete currentQueries.duration;

    router.replace(
      {
        pathname: router.pathname,
        query: {
          ...currentQueries,
        },
      },
      undefined,
      { scroll: false }
    );
  };
  return (
    <Wrapper>
      <Announcement>
        <Trans id="noBoatsFound.heading" />
      </Announcement>
      <Text>
        <Trans id="noBoatsFound.tryAgain" />
      </Text>
      <ClearSearch onClick={clearSearch}>
        <Trans id="noBoatsFound.clearSearch" />
      </ClearSearch>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  padding: 0em 3em;
`;

const Announcement = styled.div`
  font-weight: 700;
  margin-bottom: 8px;
`;

const Text = styled.div`
  margin-bottom: 32px;
`;

const ClearSearch = styled.span`
  font-weight: 700;
  color: #0751c2;
  text-decoration: none;
  text-transform: uppercase;
  cursor: pointer;
  font-size: 0.875em;
`;
